import React, { useEffect } from 'react';
import Routes from './Routes';
import { connect, useDispatch } from 'react-redux';
import { doMe } from './actions/login';
import { Loading, Message } from './components';
import Nav from './containers/Nav';

const App = ({ onLoad }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    onLoad();
  }, []);

  return (
    <div className='app mb-5'>
      <Message />
      <Loading />
      <Nav />
      <Routes />
    </div>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = { onLoad: doMe };

export default connect(mapStateToProps, mapDispatchToProps)(App);
